import { styled } from 'baseui'
import CustomToggleIcon from '@/containers/SubscriptionFormPageNew/Panel/CustomToggleIcon/CustomToggleIcon'
import PulseToggleIcon from '@/containers/SubscriptionFormPageNew/Panel/PulseToggleIcon/PulseToggleIcon'

const pulseRadius = radius => ({
  borderTopLeftRadius: radius,
  borderTopRightRadius: radius,
  borderBottomLeftRadius: radius,
  borderBottomRightRadius: radius,
})

export const StyledLi = styled('li', ({ $theme, $pulse }) =>
  $pulse
    ? {
        display: 'flex',
        justifyContent: 'space-between',
        gap: '12px',
        listStyle: 'none',
        fontSize: '13px',
        lineHeight: '18px',
        color: $theme.colors.textPulseMuted,
        paddingTop: '3px',
        paddingBottom: '3px',
        paddingLeft: '6px',
        paddingRight: '6px',
        marginLeft: '-6px',
        marginRight: '-6px',
        ...pulseRadius('6px'),
        ':hover': {
          backgroundColor: $theme.colors.bgPulseCanvas,
        },
      }
    : {
        display: 'flex',
        gap: '.25rem',
        position: 'relative',
        listStyle: 'none',
        paddingLeft: '0.75rem',
        marginBottom: '.5rem',
        '::before': {
          content: '""',
          position: 'absolute',
          left: 0,
          top: '50%',
          transform: 'translateY(-50%)',
          width: '5px',
          height: '5px',
          borderRadius: '50%',
          background: $theme.colors.grey,
        },
      },
)

export const StyledText = styled('p', ({ $theme, $pulse }) =>
  $pulse
    ? { margin: 0, fontWeight: 600, textAlign: 'right', color: $theme.colors.textPulseStrong }
    : {
        color: $theme.colors.textHeading,
      },
)

export const pulseMeterAccordionOverrides = {
  Root: {
    style: ({ $theme }) => ({
      overflow: 'hidden',
      ...pulseRadius('10px'),
      borderTopWidth: '1px',
      borderBottomWidth: '1px',
      borderLeftWidth: '1px',
      borderRightWidth: '1px',
      borderTopStyle: 'solid',
      borderBottomStyle: 'solid',
      borderLeftStyle: 'solid',
      borderRightStyle: 'solid',
      borderTopColor: $theme.colors.borderPulse,
      borderBottomColor: $theme.colors.borderPulse,
      borderLeftColor: $theme.colors.borderPulse,
      borderRightColor: $theme.colors.borderPulse,
      backgroundColor: $theme.colors.white,
    }),
  },
  PanelContainer: {
    style: ({ $theme }) => ({
      borderBottomWidth: '1px',
      borderBottomStyle: 'solid',
      borderBottomColor: $theme.colors.bgPulseTrack,
      ':last-child': {
        borderBottomWidth: 0,
      },
    }),
  },
  Header: {
    style: ({ $theme }) => ({
      paddingTop: '10px',
      paddingBottom: '10px',
      paddingLeft: '12px',
      paddingRight: '12px',
      fontSize: '13.5px',
      lineHeight: '20px',
      fontWeight: 600,
      color: $theme.colors.textPulseStrong,
      backgroundColor: $theme.colors.white,
      ':hover': {
        color: $theme.colors.textPulseStrong,
      },
    }),
  },
  Content: {
    style: ({ $theme }) => ({
      backgroundColor: $theme.colors.white,
      paddingTop: 0,
      paddingBottom: '10px',
      paddingLeft: '12px',
      paddingRight: '12px',
      color: $theme.colors.textPulseMuted,
    }),
  },
  ToggleIcon: {
    component: PulseToggleIcon,
  },
}

export const meterAccordionOverrides = {
  Root: {
    style: () => ({
      borderRadius: '.5rem',
      borderRight: '1px solid #D6D7D8',
      borderLeft: '1px solid #D6D7D8',
      borderTop: '1px solid #D6D7D8',
    }),
  },
  Content: {
    style: () => ({
      background: '#EDEEEE',
      paddingTop: '1rem',
      paddingBottom: '1rem',
      paddingLeft: '.5rem',
      paddingRight: '.5rem',
      color: '#58595B',
      ':first-child': {
        borderTop: '1px solid #D6D7D8',
      },
    }),
  },
  PanelContainer: {
    style: () => ({
      borderRadius: 'none',
      borderBottom: '1px solid #D6D7D8',
      ':last-child': {
        borderRadius: '0 0 .5rem 0.5rem',
        borderBottom: '1px solid #D6D7D8',
      },
    }),
  },
  Header: {
    style: () => ({
      borderRadius: '.5rem',
      color: '#343535',
      fontWeight: 600,
      letterSpacing: '-0.008px',
      fontSize: '.875rem',
      lineHeight: '160%',
      paddingTop: '.5rem',
      paddingBottom: '.5rem',
      paddingLeft: '.5rem',
      paddingRight: '.5rem',
      ':hover': {
        color: 'black',
      },
    }),
  },
  ToggleIcon: {
    component: CustomToggleIcon,
  },
}
